import React, { useEffect, useState, useRef } from 'react';
import './App.css';
import Calendar from "./Calender/Calendar";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import "./Login/login_page.css"

function App() {
    const optimal_num_days = () => {
        return window.innerWidth / 280 - 1
    }

    const update_Date_Cockies = (input) => {
        let currentUrl = window.location.href;
        if (currentUrl.match("localhost"))
            currentUrl = "localhost"
        else currentUrl = currentUrl.match(/\/\/(.*?)(\/|:)/)[1];
        Cookies.set('Dates', JSON.stringify(input), {
            domain: currentUrl,
            expires: 1 / 10,
            sameSite: 'Lax',
            secure: false
        })
    }
    const getDayDifference = (Datum1, Datum2) => {
        const day1 = new Date(Datum1).setHours(0, 0, 0, 0)
        const day2 = new Date(Datum2).setHours(0, 0, 0, 0)
        const timeDiff = day2 - day1;
        if (timeDiff < 0) return 0;
        const tageDifferenz = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

        return tageDifferenz;
    }

    let Date_on_load = Cookies.get('Dates');
    if (Date_on_load == null)
        Date_on_load = {
            Startdate: new Date().toISOString().split('T')[0],
            Enddate: new Date(new Date().setDate(new Date().getDate() + optimal_num_days())).toISOString().split('T')[0]
        };
    else
        Date_on_load = JSON.parse(Date_on_load)

    const [selectedstartDate, setSelectedStartDate] = useState(Date_on_load.Startdate);
    const [selectedendDate, setSelectedEndDate] = useState(Date_on_load.Enddate);
    const [expanded_nav_bar, set_expanded_nav_bar] = useState(false)
    const [filter_active, set_filter_active] = useState(false)

    const expand_nav_bar = () => {
        set_expanded_nav_bar(!expanded_nav_bar)
    }

    const handlestartDateChange = (event) => {
        const new_enddate = addDays(event.target.value, getDayDifference(selectedstartDate, selectedendDate)).toISOString().split('T')[0]
        setSelectedEndDate(new_enddate)
        setSelectedStartDate(event.target.value);
        update_Date_Cockies({ Startdate: event.target.value, Enddate: new_enddate })
    };
    const handleendDateChange = (event) => {
        setSelectedEndDate(event.target.value)
        update_Date_Cockies({ Startdate: selectedstartDate, Enddate: event.target.value })
    }



    const [datearray, setDatearray] = React.useState(null);
    const handleSubmit = () => {
        setIsLoading(true);
        get_Date_Array()
        update();
    }

    useEffect(() => {
        handleSubmit()
    }, [selectedendDate])
    const [data, setData] = React.useState(null);
    const complete_data = useRef(null)
    const [isLoading, setIsLoading] = useState(true);
    const [current_filter_id, setcurrent_filter_id] = useState(null)

    function update() {
        const path = "/api/getData";
        fetch(path, {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({
                sdate: selectedstartDate,
                edate: selectedendDate,
                token: Cookies.get('token'),
                admin: Cookies.get('admin')
            })
        }).then((res) => res.json())
            .then(new_data => {
                setData(new_data);
                complete_data.current = JSON.parse(JSON.stringify(new_data));
                setIsLoading(false)
                if (filter_active) {
                    filter_name(current_filter_id, new_data);
                }
                // Setzt isLoading auf false, wenn die Daten geladen wurden
            })


    }

    const movestartdate = (numdays) => {
        const new_startdate = addDays(selectedstartDate, numdays).toISOString().split('T')[0]
        const new_enddate = addDays(selectedendDate, numdays).toISOString().split('T')[0]
        setSelectedEndDate(new_enddate)
        setSelectedStartDate(new_startdate);
        update_Date_Cockies({ Startdate: new_startdate, Enddate: new_enddate })
    }
    const set_to_today = () => {
        const new_startdate = new Date().toISOString().split('T')[0]
        const new_enddate = addDays(new_startdate, getDayDifference(selectedstartDate, selectedendDate)).toISOString().split('T')[0]
        setSelectedEndDate(new_enddate)
        setSelectedStartDate(new_startdate);
        update_Date_Cockies({ Startdate: new_startdate, Enddate: new_enddate })
    }

    function load_old_data() {
        if (!isLoading) {
            setData(complete_data.current);
            set_filter_active(false)
            setcurrent_filter_id(null)
        }
    }

    function get_Date_Array() {
        const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]
        const timeDifference = new Date(selectedendDate) - new Date(selectedstartDate)
        const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
        const datelist = [];
        for (let i = 0; i <= daysDifference; i++) {
            let date = addDays(selectedstartDate, i)
            datelist.push(days[date.getDay()] + " - " + date.toLocaleDateString())
        }
        setDatearray(datelist)
    }


    function addDays(date, num_days) {
        let current_date = new Date(date);
        return new Date(current_date.setDate(current_date.getDate() + num_days))
    }


    let navigate = useNavigate();
    const routeChange = () => {
        let path = `/login`;
        navigate(path);
    }
    const filter_name = (input, incoming_data) => {
        if (incoming_data === null)
            incoming_data = data
        setcurrent_filter_id(input)
        if (data !== null) {
            const jsonsstring = JSON.stringify(incoming_data)
            console.log(input)
            if (input.open) {
                let newdata = filter_open_slots(JSON.parse(jsonsstring))
                setData(newdata);
            } else {
                if (input.person_id) {
                    let newdata = filter_data_by_allocation_id(JSON.parse(jsonsstring), input.person_id)
                    setData(newdata);
                } else {
                    if (input.ressource_id) {
                        let newdata = filter_data_by_ressourcetyp(JSON.parse(jsonsstring), input.ressource_id)
                        setData(newdata);
                    }
                }
            }
            set_filter_active(true)
        }

    }

    const logout = () => {
        let currentUrl = window.location.href;
        if (currentUrl.match("localhost"))
            currentUrl = "localhost"
        else currentUrl = currentUrl.match(/\/\/(.*?)(\/|:)/)[1];
        Cookies.remove('token', { domain: currentUrl });
        Cookies.remove('admin', { domain: currentUrl });
        navigate("/login");
    }


    return (

        <div style={{ background: "#0a58ca" }}>
            {Cookies.get("token") === undefined ? routeChange() : null}
            <div style={{ display: "table", width: "100%" }}>
                <div
                    style={{
                        background: "#0a58ca",
                        display: "table-row",
                        position: "sticky",
                        top: "0",
                        height: "30px",
                        zIndex: "100",

                    }}>
                    <label onClick={expand_nav_bar} style={{
                        color: "white",
                        margin: "10px",
                        marginRight: "3px",
                        fontWeight: "bold"
                    }}>Startdate: </label>
                    <input type="date"
                        id="startdate"
                        style={{ background: "bg-primary", color: "black", margin: "10px" }}
                        value={selectedstartDate}
                        onChange={handlestartDateChange}

                    />
                    {!filter_active ? <button onClick={() => {
                        filter_name({ person_id: data.user.userID }, null)
                    }}>Show my jobs
                    </button> : null}
                    {filter_active ? <button onClick={load_old_data}>Show all Slots</button> : null}
                    <button style={{ float: "right", margin: "10px" }} onClick={logout}>Logout</button>
                </div>
                {!expanded_nav_bar ? null :
                    <div
                        style={{
                            display: "table-row",
                            position: "sticky",
                            background: "#0a58ca",
                            top: "40px",
                            zIndex: "100"
                        }}>
                        <button style={{ marginLeft: "4px" }} onClick={() => {
                            movestartdate(-14)
                        }}>- 14 days
                        </button>
                        <button style={{ marginLeft: "4px" }} onClick={() => {
                            movestartdate(-7)
                        }}>- 7 days
                        </button>
                        <button style={{ marginLeft: "4px" }} onClick={() => {
                            movestartdate(-getDayDifference(selectedstartDate, selectedendDate) - 1)
                        }}>- {getDayDifference(selectedstartDate, selectedendDate) + 1} days
                        </button>
                        <button style={{ marginLeft: "4px" }} onClick={set_to_today}>Today</button>
                        <button style={{ marginLeft: "4px" }} onClick={() => {
                            movestartdate(+getDayDifference(selectedstartDate, selectedendDate) + 1)
                        }}>+ {getDayDifference(selectedstartDate, selectedendDate) + 1} days
                        </button>
                        <button style={{ marginLeft: "4px" }} onClick={() => {
                            movestartdate(7)
                        }}>+ 7 days
                        </button>
                        <button style={{ marginLeft: "4px" }} onClick={() => {
                            movestartdate(14)
                        }}>+ 14 days
                        </button>
                        <label style={{ color: "white", margin: "10px", fontWeight: "bold" }}>Enddate: </label>
                        <input
                            style={{ display: "table-column" }}
                            type="date"
                            id="enddate"
                            value={selectedendDate}
                            min={selectedstartDate}
                            onChange={handleendDateChange}

                        />
                    </div>}
                <div style={{ display: "table-row", position: "sticky" }}>
                    {isLoading ? (
                        <div style={{
                            background: "white",
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "40px 0",
                            gap: "16px"
                        }}>
                            <div style={{
                                width: "40px",
                                height: "40px",
                                border: "4px solid #e0e0e0",
                                borderTop: "4px solid #1976d2",
                                borderRadius: "50%",
                                animation: "spin 1s linear infinite"
                            }} />
                            <p style={{
                                fontSize: "20px",
                                fontWeight: "500",
                                color: "#555",
                                margin: 0
                            }}>
                                Loading Data...
                            </p>

                            <style>
                                {`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                `}
                            </style>
                        </div>
                    ) : (
                        <Calendar
                            data={data}
                            dates={datearray}
                            filter_name={filter_name}
                            expendet_datebar={expanded_nav_bar}
                        />
                    )}
                </div>

            </div>
        </div>);
}

function filter_data_by_allocation_id(data, filter_id) {

    let i = [0, 0, 0, 0, 0, 0]
    for (i[0] = data.standorte.length - 1; i[0] >= 0; i[0]--) {
        for (i[1] = data.standorte[i[0]].customer.length - 1; i[1] >= 0; i[1]--) {
            for (i[2] = data.standorte[i[0]].customer[i[1]].projects.length - 1; i[2] >= 0; i[2]--) {
                for (i[3] = data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs.length - 1; i[3] >= 0; i[3]--) {
                    if (data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs[i[3]].slots === null) {
                        data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs.splice(i[3], 1)
                    } else {
                        for (i[4] = data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs[i[3]].slots.length - 1; i[4] >= 0; i[4]--) {
                            for (i[5] = data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs[i[3]].slots[i[4]].Allocations.length - 1; i[5] >= 0; i[5]--) {
                                if (data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs[i[3]].slots[i[4]].Allocations[i[5]].IdAddress !== filter_id) {
                                    data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs[i[3]].slots[i[4]].Allocations.splice(i[5], 1)
                                    data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs[i[3]].slots[i[4]].Qty--;
                                }
                            }
                            if (data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs[i[3]].slots[i[4]].Allocations.length === 0) {
                                data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs[i[3]].slots.splice(i[4], 1)
                            }
                        }
                        if (data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs[i[3]].slots.length === 0) {
                            data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs.splice(i[3], 1)
                        }
                    }
                }
                if (data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs.length === 0) {
                    data.standorte[i[0]].customer[i[1]].projects.splice(i[2], 1);
                }
            }
            if (data.standorte[i[0]].customer[i[1]].projects.length === 0) {
                data.standorte[i[0]].customer.splice(i[1], 1);
            }
        }
        if (data.standorte[i[0]].customer.length === 0) {
            data.standorte.splice(i[0], 1);
        }
    }
    return data;
}

function filter_data_by_ressourcetyp(data, filter_id) {

    let i = [0, 0, 0, 0, 0, 0]
    for (i[0] = data.standorte.length - 1; i[0] >= 0; i[0]--) {
        for (i[1] = data.standorte[i[0]].customer.length - 1; i[1] >= 0; i[1]--) {
            for (i[2] = data.standorte[i[0]].customer[i[1]].projects.length - 1; i[2] >= 0; i[2]--) {
                for (i[3] = data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs.length - 1; i[3] >= 0; i[3]--) {
                    if (data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs[i[3]].slots === null) {
                        data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs.splice(i[3], 1)
                    } else {
                        for (i[4] = data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs[i[3]].slots.length - 1; i[4] >= 0; i[4]--) {
                            if (data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs[i[3]].slots[i[4]].resource_type !== filter_id) {
                                data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs[i[3]].slots.splice(i[4], 1)
                            }
                        }
                        if (data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs[i[3]].slots.length === 0) {
                            data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs.splice(i[3], 1)
                        }
                    }
                }
                if (data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs.length === 0) {
                    data.standorte[i[0]].customer[i[1]].projects.splice(i[2], 1);
                }
            }
            if (data.standorte[i[0]].customer[i[1]].projects.length === 0) {
                data.standorte[i[0]].customer.splice(i[1], 1);
            }
        }
        if (data.standorte[i[0]].customer.length === 0) {
            data.standorte.splice(i[0], 1);
        }
    }
    return data;
}

function filter_open_slots(data) {
    let i = [0, 0, 0, 0, 0, 0]
    for (i[0] = data.standorte.length - 1; i[0] >= 0; i[0]--) {
        for (i[1] = data.standorte[i[0]].customer.length - 1; i[1] >= 0; i[1]--) {
            for (i[2] = data.standorte[i[0]].customer[i[1]].projects.length - 1; i[2] >= 0; i[2]--) {
                for (i[3] = data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs.length - 1; i[3] >= 0; i[3]--) {
                    if (data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs[i[3]].slots === null) {
                        data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs.splice(i[3], 1)
                    } else {
                        for (i[4] = data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs[i[3]].slots.length - 1; i[4] >= 0; i[4]--) {
                            if (data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs[i[3]].slots[i[4]].Allocations.length === data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs[i[3]].slots[i[4]].Qty) {

                                console.log(data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs[i[3]].slots[i[4]].Allocations.length)
                                console.log(data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs[i[3]].slots[i[4]].Qty)
                                data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs[i[3]].slots.splice(i[4], 1)
                            } /*else {
                                for (i[5] = data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs[i[3]].slots[i[4]].Allocations.length - 1; i[5] >= 0; i[5]--) {
                                    data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs[i[3]].slots[i[4]].Allocations.Qty--
                                    i[5] = data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs[i[3]].slots[i[4]].Allocations.splice(i[5],1)
                                }
                                if (data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs[i[3]].slots[i[4]].Allocations.length === 0) {
                                    data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs[i[3]].slots.splice(i[4], 1)
                                }
                            }*/
                        }
                        if (data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs[i[3]].slots.length === 0) {
                            data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs.splice(i[3], 1)
                        }
                    }
                }
                if (data.standorte[i[0]].customer[i[1]].projects[i[2]].jobs.length === 0) {
                    data.standorte[i[0]].customer[i[1]].projects.splice(i[2], 1);
                }
            }
            if (data.standorte[i[0]].customer[i[1]].projects.length === 0) {
                data.standorte[i[0]].customer.splice(i[1], 1);
            }
        }
        if (data.standorte[i[0]].customer.length === 0) {
            data.standorte.splice(i[0], 1);
        }
    }
    return data;
}

export default App;
